module.exports = __webpack_public_path__ + "static/media/explore-and-learn-page.5ec6a2a3.png";